import { useState } from "react";
import { useFlags } from "launchdarkly-react-client-sdk";
import { useOrganizationReference } from "../pages/facility/hooks/useOrganization";
import { TCopilot } from "../types/copilot";
import useMedicalEncounter from "./useMedicalEncounter";

type TUseCopilot = {
  copilotData: TCopilot;
  setCopilotData: (e) => void;
  copilotActive: boolean;
  setCopilotActive: (e: boolean) => void;
  copilotEnabled: boolean;
  audioLevel: number;
  setAudioLevel: (level: number) => void;
  isProcessingTranscript: boolean;
  setIsProcessingTranscript: (processing: boolean) => void;
  /** In-progress speech from Deepgram (interim and speech_final text for live display) */
  liveTranscript: string;
  setLiveTranscript: (text: string) => void;
};

export function useCopilot(): TUseCopilot {
  const { allowCopilot } = useFlags();
  const {
    copilot,
    isCopiloting,
    setCopilot,
    setIsCopiloting,
    isProcessingTranscript,
    setIsProcessingTranscript,
    liveTranscript,
    setLiveTranscript,
  } = useMedicalEncounter();

  const [audioLevel, setAudioLevel] = useState(0);

  return {
    copilotData: copilot,
    setCopilotData: setCopilot,
    copilotActive: isCopiloting,
    setCopilotActive: setIsCopiloting,
    copilotEnabled: allowCopilot,
    audioLevel,
    setAudioLevel,
    isProcessingTranscript,
    setIsProcessingTranscript,
    liveTranscript,
    setLiveTranscript,
  };
}
